import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid
} from "@mui/material";
import apiService from "../../service/apiService";
import { FaEye, FaRegEdit, FaTrash } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import UploadIcon from '@mui/icons-material/Upload';
import { Download } from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import { debounce } from "lodash";

const ProducergroupData = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Essential state variables only
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openview, setOpenview] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [detaiilsview, setDetailsview] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [pgName, setPgName] = useState("");
  const [pgCode, setPgCode] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [gp, setGp] = useState("");
  const [village, setVillage] = useState("");
  const [presidentName, setPresidentName] = useState("");
  const [presidentPhone, setPresidentPhone] = useState("");
  const [secretaryName, setSecretaryName] = useState("");
  const [secretaryPhone, setSecretaryPhone] = useState("");
  const [formationDate, setFormationDate] = useState("");
  const [accountNumber, setAcountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [ifscCode, setIFSCCode] = useState("");
  const [coreactivities, setCoreActivities] = useState("");
  const [producerGroupId, setProducerGroupId] = useState(null);
  
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(
    loginData?.districtId !== null && loginData?.districtId !== undefined 
      ? loginData.districtId 
      : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0) 
  );
  const [blk, setBlk] = useState(
    loginData?.blockId !== null && loginData?.blockId !== undefined 
      ? loginData.blockId 
      : (location.state?.blk && location.state.blk !== 0 ? location.state.blk : 0)
  );
  const [gpid, setGpid] = useState(0);
  
  const [facilitators, setFacilitators] = useState([]);
  const [fpos, setFpos] = useState([]);
  const [dists, setAllDists] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [gps, setGps] = useState([]);
  const [vlgs, setVlgs] = useState([]);
  
  const isDistCoordinator = loginData?.districtCoordinatorsId !== null;
  const isBlockCoordinator = loginData?.blockCoordinatorsId !== null;
  
  const [formData, setFormData] = useState({
    pgName: "",
    pgCode: "",
    ifscCode: "",
    bankName: "",
    accountNumber: "",
    villageId: 0,
    districtId: 0,
    blockId: 0,
    gpId: 0,
    pGFId: 0,
    fpoId: 0,
    presidentName: "",
    presidentMobileNo: "",
    secretaryName: "",
    secretaryMobileNo: "",
    availableBalance: 0,
    coreactivities: ""
  });

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  // Essential useEffects
  useEffect(() => {
    const requiredFields = [
      "pgName", "districtId", "blockId", "gpId", "villageId", "presidentName",
      "presidentMobileNo", "secretaryName", "secretaryMobileNo", "bankName",
      "accountNumber", "ifscCode"
    ];
    const isAnyFieldEmpty = requiredFields.some(
      (field) => !formData[field] || formData[field] === 0
    );
    setIsSaveDisabled(isAnyFieldEmpty);
  }, [formData]);

  const fetchFacilitators = async () => {
    try {
      const response = await apiService.get("/producer-group-facilitators/get-all");
      setFacilitators(response.data);
    } catch (error) {
      console.error("Error fetching facilitators:", error);
    }
  };

  const fetchFPOs = async () => {
    try {
      const response = await apiService.get("/fpo/get-all");
      const fpoList = response.data.map(item => ({
        fpoid: item.fpoid,
        fponame: item.fponame,
      }));
      setFpos(fpoList);
    } catch (error) {
      console.error("Error fetching FPOs:", error);
    }
  };

  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
      const currentdist = loginData?.districtId !== null && loginData?.districtId !== undefined 
        ? loginData.districtId 
        : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0);
      const defdist = response.data.find((dis) => dis.districtId === currentdist);
      setDistrict(defdist ? defdist.districtName : "");
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      setBlocks(response.data.body.blocks);
      const currentblock = loginData?.blockId !== null && loginData?.blockId !== undefined 
        ? loginData.blockId 
        : (location.state?.block && location.state.block !== 0 ? location.state.block : 0);
      const defblock = response.data.body.blocks.find((blk) => blk.blockId === currentblock);
      setBlock(defblock ? defblock.blockName : "");
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  const fetchGP = async () => {
    try {
      const response = await apiService.get(`/master/get-gp-by-block/${blk}`);
      setGps(response.data.body.gpList);  
    } catch (error) {
      console.error("Error fetching GPs:", error);
    }
  };

  const fetchVlg = async () => {
    try {
      const response = await apiService.get(`/master/get-village-by-gp/${gpid}`);
      setVlgs(response.data.body);  
    } catch (error) {
      console.error("Error fetching villages:", error);
    }
  };

  useEffect(() => {
    fetchFacilitators();
    fetchFPOs();
    fetchAllDist();
  }, []);

  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  useEffect(() => {
    if (blk > 0) {
      fetchGP();
    }
  }, [blk]);

  useEffect(() => {
    if (gpid > 0) {
      fetchVlg();
    }
  }, [gpid]);

  const fetchData = async () => {
    try {
      const response = await apiService.post("/producer-groups/get-all-index-data", {
        villageId: 0, mipId: 0, blockId: 0, districtId: 0, producerGroupId: 0,
        pageNumber: page, pageSize: pageSize, pgName: pgName, pgCode: pgCode,
        formationDate: formationDate || "", presidentName: presidentName,
        secretaryName: secretaryName, presidentMobileNo: presidentPhone,
        secretaryMobileNo: secretaryPhone, villageName: village, gpName: gp,
        blockName: block, districtName: district, stateName: "", bankName: bankName,
        ifscCode: ifscCode, accountNumber: accountNumber, availableBalance: 0,
        coreactivities: coreactivities
      });

      const data = response.data.body.data;
      const formattedData = data.map((item) => ({
        id: item.producerGroupId,
        producerGroupId: item.producerGroupId,
        districtName: item.districtName,
        blockName: item.blockName,
        gpName: item.gpName,
        scFarmers: item.scFarmers,
        formationDate: item.formationDate,
        presidentMobileNo: item.presidentMobileNo,
        villageName: item.villageName,
        femaleFarmers: item.femaleFarmers,
        pgName: item.pgName,
        pgCode: item.pgCode,
        secretaryName: item.secretaryName,
        obcFarmers: item.obcFarmers,
        presidentName: item.presidentName,
        stateName: item.stateName,
        stFarmers: item.stFarmers,
        secretaryMobileNo: item.secretaryMobileNo,
        mipName: item.mipName,
        totalFarmers: item.totalFarmers,
        maleFarmers: item.maleFarmers,
        genFarmers: item.genFarmers,
        accountNumber: item.accountNumber,
        bankName: item.bankName,
        ifscCode: item.ifscCode,
        availableLand: item.totalAvailableLand || 0,
        availableBalance: item.availableBalance || 0,
        coreactivities: item.coreactivities
      }));
      
      setRows(formattedData);
      setTotalitems(response.data.body.recordsCount);
      setTotalpage(response.data.body.pageCount);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRows([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    page, pageSize, pgName, pgCode, district, block, gp, village, presidentName,
    presidentPhone, secretaryName, secretaryPhone, formationDate, accountNumber,
    bankName, ifscCode, coreactivities
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const handleEdit = async (row) => {
    const { producerGroupId } = row; 
    try {
      const response = await apiService.get(`/producer-group/${producerGroupId}`);
      if (response.status === 200) {
        const fetchedData = response.data;
        setProducerGroupId(producerGroupId); 
        setDist(fetchedData.districtId);
        setBlk(fetchedData.blockId);
        setGpid(fetchedData.gpId);
        setFormData({
          pgName: fetchedData.pgName || "",
          pgCode: fetchedData.pgCode || "",
          ifscCode: fetchedData.ifscCode || "",
          bankName: fetchedData.bankName || "",
          accountNumber : fetchedData.accountNumber || "",
          districtId : Number(fetchedData.districtId) || 0,
          blockId : Number(fetchedData.blockId) || 0,
          gpId : Number(fetchedData.gpId) || 0,
          villageId: Number(fetchedData.villageId) || 0,
          pGFId: Number(fetchedData.producerGroupFacilitatorId) || 0,
          fpoId: fetchedData.fpoId || 0,
          presidentName : fetchedData.producerGroupHead || "",
          presidentMobileNo : fetchedData.producerGroupHeadMobileNo || "",
          secretaryName : fetchedData.producerGroupSecretary || "",
          secretaryMobileNo : fetchedData.producerGroupSecretaryMobileNo || "",
          availableBalance : fetchedData.availableBalance || 0,
          coreactivities : fetchedData.coreactivities || "",
        });
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching producer group details:", error);
    }
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpenDelete(true); 
  };

  const handleDelete = async () => {
    try {
      const { producerGroupId } = selectedRow;
      await apiService.delete(`/producer-groups/delete/${producerGroupId}`);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setOpenDelete(false);
    }
  };

  const handleView = async (row) => {
    const { producerGroupId } = row;
    try {
      const response = await apiService.get(`/producer-group/${producerGroupId}`);
      if (response.status === 200) {
        setDetailsview(response.data);
        setOpenview(true);
      }
    } catch (error) {
      console.error("Error fetching producer group details:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!producerGroupId) {
      alert("Producer Group ID is missing. Please try again.");
      return;
    }
  
    const payload = {
      pgName: formData.pgName,
      ifscCode: formData.ifscCode,
      bankName: formData.bankName,
      accountNumber: formData.accountNumber,
      villageId: formData.villageId,
      producerGroupFacilitatorId: formData.pGFId,
      fpoId: formData.fpoId,
      presidentName: formData.presidentName,
      presidentMobileNo: formData.presidentMobileNo,
      secretaryName: formData.secretaryName,
      secretaryMobileNo: formData.secretaryMobileNo,
      availableBalance: Number(formData.availableBalance),
      coreactivities: formData.coreactivities
    };
  
    try {
      await apiService.put(`/producer-groups/update/${producerGroupId}`, payload);
      alert("Producer group updated successfully!");
      handleClose();
      fetchData();
    } catch (error) {
      console.error("Error updating producer group:", error);
      alert("Failed to update producer group. Please try again.");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenview(false);
    setDist(loginData?.districtId !== null && loginData?.districtId !== undefined 
      ? loginData.districtId 
      : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0));
    setBlk(loginData?.blockId !== null && loginData?.blockId !== undefined 
      ? loginData.blockId 
      : (location.state?.blk && location.state.blk !== 0 ? location.state.blk : 0));
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleExcelUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const confirmUpload = window.confirm("Are you sure you want to upload this file?");
    if (!confirmUpload) return;

    const formData = new FormData();
    formData.append('file', file);

    apiService.post('/upload/pg-upload', formData, {
      headers: {
        'accept': '*/*',
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        alert("File uploaded successfully!");
        fetchData();
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        alert("Failed to upload file. Please try again.");
      });
  };

  const handleDownloadExcel = () => {
    const headers = [
      "SlNo", "Code", "District", "Block", "GP", "MIP", "PaniPanchayat", "Village",
      "PGName", "PresidentName", "PhoneNo", "SecretaryName", "PhoneNo", "AccountNumber",
      "BankName", "IFSC", "FormationDate", "AvailableBalance", "CoreActivities"
    ];
    const worksheetData = [headers];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "producer_group_data.xlsx");
  };

  const exportToExcel = async () => {
    try {
      const response = await apiService.post("/producer-groups/get-all-index-data", {
        villageId: 0, mipId: 0, blockId: 0, districtId: 0, producerGroupId: 0,
        pageNumber: 1, pageSize: totalItems, pgName: pgName || "", pgCode: pgCode || "",
        formationDate: formationDate || "", presidentName: presidentName || "",
        secretaryName: secretaryName || "", presidentMobileNo: presidentPhone || "",
        secretaryMobileNo: secretaryPhone || "", villageName: village || "",
        gpName: gp || "", blockName: block || "", districtName: district || "",
        stateName: "", bankName: bankName || "", ifscCode: ifscCode || "",
        accountNumber: accountNumber || "", availableBalance: 0,
        coreActivities: coreactivities || ""
      });

      const data = response.data.body.data;
      const headers = [
        "PG", "PG Code", "District", "Block", "G.P", "Village", "Members No.",
        "Male", "Female", "General", "OBC", "SC", "ST", "President", "President Ph.No",
        "Secretary", "Secretary Ph.No", "Formation Date", "AccountNumber", "BankName",
        "IFSCCODE", "AvailableBalance", "CoreActivities"
      ];

      const formattedData = data.map((item) => [
        item.pgName, item.pgCode, item.districtName, item.blockName, item.gpName,
        item.villageName, item.totalFarmers, item.maleFarmers, item.femaleFarmers,
        item.genFarmers || "0", item.obcFarmers, item.scFarmers, item.stFarmers,
        item.presidentName, item.presidentMobileNo, item.secretaryName,
        item.secretaryMobileNo, item.formationDate, item.accountNumber,
        item.bankName, item.ifscCode, item.availableBalance || "0", item.coreActivities
      ]);

      const sheetData = [headers, ...formattedData];
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Producer Groups");
      XLSX.writeFile(workbook, "producer_group_data.xlsx");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  return (
    <Box style={{
      backgroundColor: "#f8f9fa",
      overflowY: "auto"
    }}>
      {/* Header - Same design as other components */}
      <div style={{
        backgroundColor: "#ffffff",
        borderBottom: "3px solid #007bff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center py-3 px-4">
            <div className="d-flex align-items-center">
              <div>
                <h1 style={{
                  fontSize: "1.8rem",
                  fontWeight: "600",
                  color: "#2c3e50",
                  margin: "0"
                }}>
                  Producer Group Management
                </h1>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="contained"
                onClick={() => navigate('/addPgdata')}
                style={{
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                + Add New
              </Button>
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadIcon />}
                style={{
                  backgroundColor: "#6c757d",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Upload Excel
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleExcelUpload}
                />
              </Button>
              <Button
                variant="contained"
                onClick={handleDownloadExcel}
                style={{
                  backgroundColor: "#17a2b8",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Download Format
              </Button>
              <Button
                variant="contained"
                startIcon={<Download />}
                onClick={exportToExcel}
                style={{
                  backgroundColor: "#007bff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none"
                }}
              >
                Export Excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - Same design as other components */}
      <div className="container-fluid" style={{ padding: "20px" }}>
        <div style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 160px)"
        }}>
          <div style={{
            flex: "1",
            overflowY: "auto",
            overflowX: "auto"
          }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0" style={{
                minWidth: "2400px",
                backgroundColor: "#fff"
              }}>
                <thead style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  position: "sticky",
                  top: "0",
                  zIndex: "10"
                }}>
                  <tr>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "60px"
                    }}>
                      SL
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      PG
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={pgName}
                        onChange={(e) => { setPgName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      PG Code
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={pgCode}
                        onChange={(e) => { setPgCode(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={district}
                        onChange={(e) => {
                          if (dist === 0) { 
                            setDistrict(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={dist > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={block}
                        onChange={(e) => {
                          if (blk === 0) { 
                            setBlock(e.target.value);
                            setPage(1);
                          }
                        }}
                        disabled={blk > 0}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={gp}
                        onChange={(e) => { setGp(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={village}
                        onChange={(e) => { setVillage(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Total Members
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      Male
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      Female
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      General
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      OBC
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      SC
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "75px",
                      textAlign: "center"
                    }}>
                      ST
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      President
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={presidentName}
                        onChange={(e) => { setPresidentName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      President Ph.No
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={presidentPhone}
                        onChange={(e) => { setPresidentPhone(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Secretary
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={secretaryName}
                        onChange={(e) => { setSecretaryName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px"
                    }}>
                      Secretary Ph.No
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={secretaryPhone}
                        onChange={(e) => { setSecretaryPhone(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "140px"
                    }}>
                      Formation Date
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm mt-2"
                        value={formationDate}
                        onChange={(e) => { setFormationDate(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "170px"
                    }}>
                      Account Number
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={accountNumber}
                        onChange={(e) => { setAcountNumber(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "170px"
                    }}>
                      Bank Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={bankName}
                        onChange={(e) => { setBankName(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px"
                    }}>
                      IFSC CODE
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={ifscCode}
                        onChange={(e) => { setIFSCCode(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "100px",
                      textAlign: "center"
                    }}>
                      Agri. Land (ha)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "120px",
                      textAlign: "center"
                    }}>
                      Avl. Balance (₹)
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      borderRight: "1px solid rgba(255,255,255,0.2)",
                      minWidth: "150px"
                    }}>
                      Core Activities
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm mt-2"
                        value={coreactivities}
                        onChange={(e) => { setCoreActivities(e.target.value); setPage(1); }}
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#333",
                          padding: "4px 8px"
                        }}
                      />
                    </th>
                    <th style={{
                      padding: "15px 12px",
                      fontWeight: "600",
                      fontSize: "13px",
                      textAlign: "center",
                      minWidth: "120px"
                    }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {rows.map((data, index) => (
                    <tr key={index} style={{
                      backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                      borderBottom: "1px solid #dee2e6"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e3f2fd";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                      }}>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {(page - 1) * 10 + index + 1}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.pgName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.pgCode}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.districtName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.blockName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.gpName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.villageName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.totalFarmers}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#28a745',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.maleFarmers}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#dc3545',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.femaleFarmers}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.genFarmers || '0'}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.obcFarmers}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.scFarmers}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.stFarmers}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.presidentName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.presidentMobileNo}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.secretaryName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.secretaryMobileNo}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontWeight: "500"
                      }}>
                        {data.formationDate ? format(parseISO(data.formationDate), "dd-MM-yyyy") : "N/A"}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.accountNumber}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.bankName}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        {data.ifscCode}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#6f42c1',
                          color: 'white',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.availableLand}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6"
                      }}>
                        <span style={{
                          backgroundColor: '#ffc107',
                          color: '#212529',
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}>
                          {data.availableBalance}
                        </span>
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        color: "#495057",
                        borderRight: "1px solid #dee2e6",
                        fontSize: "12px"
                      }}>
                        {data.coreactivities}
                      </td>
                      <td style={{
                        padding: "12px 8px",
                        textAlign: "center"
                      }}>
                        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => handleView(data)}
                            title="View"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaEye />
                          </button>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleEdit(data)}
                            title="Edit"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaRegEdit />
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteClick(data)}
                            title="Delete"
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px"
                            }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pagination - Same design as other components */}
        <div className='d-flex justify-content-between align-items-center py-3 px-3' style={{
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #dee2e6"
        }}>
          <div>
            <span style={{
              color: "#6c757d",
              fontSize: "14px"
            }}>
              Showing <strong>{(page - 1) * 10 + 1}</strong> to <strong>{Math.min(page * 10, totalItems)}</strong> of <strong>{totalItems}</strong> entries
            </span>
          </div>
          <div>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

      {/* View Dialog */}
      <Dialog open={openview} onClose={handleClose} fullWidth>
        <DialogTitle style={{fontWeight:"bold", fontSize:"30px"}}>PG Management</DialogTitle>
        <DialogContent>
          {detaiilsview && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Pg name:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.pgName}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>PG Code:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.pgCode}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>District:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.district}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Block:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.block}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>G.P:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.gp}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Village:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.village}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Total No of Members:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.totalFarmers}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>President Name:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.producerGroupHead}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>President Ph No:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.producerGroupHeadMobileNo}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Secretary Name:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.producerGroupSecretary}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Secretary Ph No:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.producerGroupSecretaryMobileNo}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Formation Date:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.registrationDate ? format(parseISO(detaiilsview.registrationDate), "dd-MM-yyyy") : "N/A"}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary"><strong>Available Balance:</strong></Typography>
                  <Typography variant="body1">{detaiilsview.availableBalance || 0}</Typography>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth>
        <div className='mx-3 mt-2 d-flex justify-content-between'>
          <h4 className='text-bold'>Edit Producer Group Data</h4>
          <p><span className='text-danger text-bold' style={{fontSize:"18px"}}>*</span> mark fields are mandatory</p>
        </div>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                name="pgName"
                label={<>Producer Group Name <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.pgName}
                onChange={handleChange}
                margin="dense"
              />
              <FormControl fullWidth margin="dense">
                <InputLabel id="dist-label">Dist<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="dist-label"
                  label={<>Dist <span style={{ color: "red" }}>*</span></>}
                  name="districtId"
                  value={formData.districtId}
                  onChange={(e) => {
                    setDist(e.target.value);
                    setFormData((prev) => ({ ...prev, districtId: e.target.value }));
                  }}
                  disabled={isDistCoordinator}
                  variant="outlined"
                >
                  {dists.map((d) => (
                    <MenuItem key={d.districtId} value={d.districtId}>
                      {d.districtName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel id="block-label">Block<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="block-label"
                  label={<>Block <span style={{ color:                  "red" }}>*</span></>}
                  name="blockId"
                  value={formData.blockId}
                  onChange={(e) => {
                    setBlk(e.target.value);
                    setFormData((prev) => ({ ...prev, blockId: e.target.value }));
                  }}
                  disabled={isBlockCoordinator}
                  variant="outlined"
                >
                  {blocks.map((b) => (
                    <MenuItem key={b.blockId} value={b.blockId}>
                      {b.blockName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel id="gp-label">GP<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="gp-label"
                  label={<>GP <span style={{ color: "red" }}>*</span></>}
                  value={formData.gpId}
                  name="gpId"
                  onChange={(e) => {
                    setGpid(e.target.value);
                    setFormData((prev) => ({ ...prev, gpId: e.target.value }));
                  }}
                  variant="outlined"
                >
                  {gps.map((d) => (
                    <MenuItem key={d.gpId} value={d.gpId}>
                      {d.gpName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel id="village-label">Village<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="village-label"
                  label={<>Village <span style={{ color: "red" }}>*</span></>}
                  name="villageId"
                  value={formData.villageId || 0}
                  onChange={handleChange}
                  variant="outlined"
                >
                  {vlgs.map((v) => (
                    <MenuItem key={v.villageId} value={v.villageId}>
                      {v.villageName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel id="facilitator-label">Facilitator<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="facilitator-label"
                  label={<>Facilitator <span style={{ color: "red" }}>*</span></>}
                  name="pGFId"
                  value={formData.pGFId || 0}
                  onChange={handleChange}
                  variant="outlined"
                >
                  {facilitators.map((f) => (
                    <MenuItem key={f.producerGroupFacilitatorId} value={f.producerGroupFacilitatorId}>
                      {f.userName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel id="fpo-label">FPO<span style={{ color: "red" }}> *</span></InputLabel>
                <Select
                  labelId="fpo-label"
                  name="fpoId"
                  label={<>FPO <span style={{ color: "red" }}>*</span></>}
                  value={formData.fpoId || 0}
                  onChange={handleChange}
                  variant="outlined"
                >
                  {fpos.map((fpo) => (
                    <MenuItem key={fpo.fpoid} value={fpo.fpoid}>
                      {fpo.fponame}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                name="coreactivities"
                label={<>Core Activities <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.coreactivities}
                onChange={handleChange}
                margin="dense"
              />
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} md={6}>
              <TextField
                name="presidentName"
                label={<>President Name <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.presidentName}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="presidentMobileNo"
                label={<>President Contact Number <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.presidentMobileNo}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="secretaryName"
                label={<>Secretary Name <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.secretaryName}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="secretaryMobileNo"
                label={<>Secretary Contact Number <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.secretaryMobileNo}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="bankName"
                label={<>Bank Name <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.bankName}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="accountNumber"
                label={<>Account Number <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.accountNumber}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="ifscCode"
                label={<>IFSC Code <span style={{ color: "red" }}>*</span></>}
                fullWidth
                value={formData.ifscCode}
                onChange={handleChange}
                margin="dense"
              />
              <TextField
                name="availableBalance"
                label="Available Balance"
                fullWidth
                value={formData.availableBalance}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, availableBalance: Number(e.target.value) }));
                }}
                margin="dense"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} disabled={isSaveDisabled} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="error" style={{ marginTop: '16px' }}>
            Are you sure you want to delete this Producer Group?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleDelete} color="error">Yes</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProducergroupData;
